import React from "react";
import { Button, Row, Col } from "react-bootstrap";
import event1 from "../Images/eventGallery/oath(2025-2026)/event1.jpg";
import event2 from "../Images/eventGallery/oath(2025-2026)/event2.jpg";
import event3 from "../Images/eventGallery/oath(2025-2026)/event3.jpg";
import event4 from "../Images/eventGallery/oath(2025-2026)/event4.jpg";
import event5 from "../Images/eventGallery/oath(2025-2026)/event5.jpg";
import event6 from "../Images/eventGallery/oath(2025-2026)/event6.jpg";
import event7 from "../Images/eventGallery/oath(2025-2026)/event7.jpg";
import event8 from "../Images/eventGallery/oath(2025-2026)/event8.jpg";
import event9 from "../Images/eventGallery/oath(2025-2026)/event9.jpg";
import event10 from "../Images/eventGallery/oath(2025-2026)/event10.jpg";
import event11 from "../Images/eventGallery/oath(2025-2026)/event11.jpg";
import event12 from "../Images/eventGallery/oath(2025-2026)/event12.jpg";
import event13 from "../Images/eventGallery/oath(2025-2026)/event13.jpg";
import event14 from "../Images/eventGallery/oath(2025-2026)/event14.jpg";
import event15 from "../Images/eventGallery/oath(2025-2026)/event15.jpg";

const EventGallery = () => {
  return (
    <>
      <section className="p-5 mx-md-5">
        <h1>Event Gallery ( Oath Ceremony 2025-26 )</h1>
        <Row className="mt-4 g-sm-2">
          <Col md={4} sm={11} className="mt-sm-1 mt-md-0">
            <img src={event1} class="img-fluid h-100 " alt="img..." />
          </Col>
          <br />
          <Col md={4} sm={11} className="mt-1 mt-md-0">
            <img src={event2} class="img-fluid h-100 " alt="img..." />
          </Col>
          <Col md={4} sm={11} className="mt-1 mt-md-0">
            <img src={event3} class="img-fluid h-100 " alt="img..." />
          </Col>
        </Row>
        <Row className="mt-2 g-sm-2">
          <Col md={4} sm={11} className="mt-1 mt-md-0">
            <img src={event4} class="img-fluid h-100" alt="img..." />
          </Col>
          <Col md={4} sm={11} className="mt-1 mt-md-0">
            <img src={event5} class="img-fluid h-100" alt="img..." />
          </Col>
          <Col md={4} sm={11} className="mt-1 mt-md-0">
            <img src={event6} class="img-fluid h-100 " alt="img..." />
          </Col>
        </Row>
        <Row className="mt-2 g-sm-2">
          <Col md={4} sm={11} className="mt-1 mt-md-0">
            <img src={event7} class="img-fluid h-100 " alt="img..." />
          </Col>
          <Col md={4} sm={11} className="mt-1 mt-md-0">
            <img src={event8} class="img-fluid h-100 " alt="img..." />
          </Col>
          <Col md={4} sm={11} className="mt-1 mt-md-0">
            <img src={event9} class="img-fluid h-100 " alt="img..." />
          </Col>
        </Row>
        <Row className="mt-2 g-sm-2">
          <Col md={4} sm={11} className="mt-1 mt-md-0">
            <img src={event10} class="img-fluid h-100 " alt="img..." />
          </Col>
          <Col md={4} sm={11} className="mt-1 mt-md-0">
            <img src={event11} class="img-fluid h-100 " alt="img..." />
          </Col>
          <Col md={4} sm={11} className="mt-1 mt-md-0">
            <img src={event12} class="img-fluid h-100 " alt="img..." />
          </Col>
        </Row>
        <Row className="mt-2 g-sm-2">
          <Col md={4} sm={11} className="mt-1 mt-md-0">
            <img src={event13} class="img-fluid h-100 " alt="img..." />
          </Col>
          <Col md={4} sm={11} className="mt-1 mt-md-0">
            <img src={event14} class="img-fluid h-100 " alt="img..." />
          </Col>
          <Col md={4} sm={11} className="mt-1 mt-md-0">
            <img src={event15} class="img-fluid h-100 " alt="img..." />
          </Col>
        </Row>
      </section>
    </>
  );
};

export default EventGallery;
